import React, {useRef} from 'react';

import {DetailPageActivitySidebar} from 'app/components/general/DetailPageActivitySidebar';
import {SidebarItem} from 'app/general/structures/SidebarItem';
import {getObjectActivityURL} from 'app/urls';
import {getContentType} from 'app/utils/content-type';
import {gt} from 'app/utils/i18n';

import type {
  LeftSidebarElementType,
  LeftSidebarMenuButton,
  LeftSidebarPanelType,
} from 'app/components/general/DetailPage/LeftSidebar/structure/types';
import type {DetailPageItemType} from 'app/components/general/DetailPage/types';

function ActivityPanelContent<ItemType extends DetailPageItemType>({
  object,
}: LeftSidebarPanelType<ItemType>) {
  const contentType = getContentType(object.content_type);
  const contentArgs = useRef({target: gt('this %s', contentType.name)});
  return (
    <DetailPageActivitySidebar
      title={gt('%s Activity', contentType.name)}
      objectId={object.id}
      closeUrl={object.html_url}
      showExportButton={object.can_edit}
      contentType={object.content_type}
      contentArgs={contentArgs.current}
    />
  );
}

function ActivityMenuButton<ItemType extends DetailPageItemType>({
  object,
  forceTooltipShow,
  hideTooltip,
  location,
  active,
}: LeftSidebarMenuButton<ItemType>) {
  const contentType = getContentType(object.content_type);
  return (
    <SidebarItem
      title={gt('%s Activity', contentType.name)}
      active={active}
      icon="fa fa-signal"
      link={getObjectActivityURL(object, location.search)}
      forceTooltipShow={forceTooltipShow}
      onClick={hideTooltip}
    />
  );
}

export const ActivitySidebar: LeftSidebarElementType<DetailPageItemType> = {
  Panel: ActivityPanelContent,
  MenuButton: ActivityMenuButton,
  type: 'left',
  sidebarName: 'showActivity',
};
